<!-- <template>
  <div class="discount-management-container">
    <transition name="toast">
      <div v-if="notification.show" class="toast-notification" :class="notification.type">
        <v-icon size="20" color="white">{{ notification.icon }}</v-icon>
        <div class="toast-content">
          <span class="toast-title">{{ notification.title }}</span>
          <span class="toast-msg">{{ notification.message }}</span>
        </div>
      </div>
    </transition>

    <div class="header-section">
      <div class="title-area">
        <h2>DISCOUNT GROUPS</h2>
        <p>Create & manage discount categories based on customer data.</p>
      </div>
      <button class="btn-back" @click="goBack">
        <v-icon size="18" color="#404a5f">mdi-chevron-left</v-icon> BACK
      </button>
    </div>

    <div class="main-card">
      <div class="card-header-row">
        <div class="placeholder"></div>
        <div class="action-header-btns">
          <button class="btn-create-outline" @click="openCreateModal">CREATE DISCOUNT GROUP</button>
          <button class="export-btn pdf" @click="exportToPDF">
            <v-icon size="18" class="mr-1">mdi-file-pdf-box</v-icon> PDF
          </button>
          <button class="export-btn excel" @click="exportToExcel">
            <v-icon size="18" class="mr-1">mdi-file-excel-box</v-icon> Excel
          </button>
        </div>
      </div>

      <div class="filters-row">
        <div class="filter-item">
          <label>Category</label>
          <select v-model="filters.category">
            <option value="">Select discount category</option>
            <option value="Cash">Cash</option>
            <option value="Credit">Credit</option>
            <option value="Return">Return</option>
          </select>
        </div>
        <div class="filter-item">
          <label>Group Name</label>
          <select v-model="filters.groupName">
            <option value="">Select group name</option>
            <option v-for="name in uniqueGroupNames" :key="name" :value="name">{{ name }}</option>
          </select>
        </div>
        <div class="filter-item search-field">
          <label>Search</label>
          <input v-model="searchQuery" type="text" placeholder="Search" />
        </div>
      </div>

      <div class="table-container">
        <table class="discount-table">
          <thead>
            <tr>
              <th>GROUP NAME</th>
              <th>DISCOUNT %</th>
              <th>PERIOD</th>
              <th>CATEGORY</th>
              <th>DESCRIPTION</th>
              <th class="text-right">ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in paginatedData" :key="index">
              <td>{{ item.groupName }}</td>
              <td>{{ item.discount }}%</td>
              <td>{{ item.period }} Days</td>
              <td>{{ item.category }}</td>
              <td>{{ item.description }}</td>
              <td class="text-right">
                <div class="dropdown-container">
                  <button @click="toggleDropdown(index)" class="actions-trigger">
                    ACTIONS <v-icon size="14">mdi-chevron-down</v-icon>
                  </button>
                  <div v-if="activeDropdown === index" class="actions-menu">
                    <div class="menu-opt" @click="editItem(item)">Edit</div>
                    <div class="menu-opt delete" @click="deleteItem(item)">Delete</div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="pagination-bar">
        <div class="page-range">
          {{ paginationRange }} of {{ filteredData.length }}
        </div>
        <div class="pagination-right">
          <span class="rows-label">Rows per page:</span>
          <select v-model="rowsPerPage" class="rows-select">
            <option :value="5">05</option>
            <option :value="10">10</option>
          </select>
          <div class="nav-arrows">
            <button :disabled="currentPage === 1" @click="currentPage--" class="arrow-btn">
              <v-icon size="18">mdi-chevron-left</v-icon>
            </button>
            <span class="current-total">{{ currentPage }}/{{ totalPages }}</span>
            <button :disabled="currentPage === totalPages" @click="currentPage++" class="arrow-btn">
              <v-icon size="18">mdi-chevron-right</v-icon>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showModal" class="modal-overlay">
      <div class="modal-content">
        <div class="modal-header">
          <h3>{{ isEditMode ? 'UPDATE DISCOUNT GROUP' : 'CREATE DISCOUNT GROUP' }}</h3>
          <button class="close-modal" @click="closeModal">×</button>
        </div>
        <div class="modal-body">
          <div class="input-group">
            <label>Group Name *</label>
            <input type="text" v-model="editingItem.groupName" placeholder="Create area name" />
          </div>
          <div class="input-group">
            <label>Discount *</label>
            <input type="text" v-model="editingItem.discount" placeholder="Create area name" />
          </div>
          <div class="input-group">
            <label>Group Category *</label>
            <select v-model="editingItem.category">
              <option value="" disabled selected>Select group category</option>
              <option value="Cash">Cash Discount</option>
              <option value="Credit">Credit Discount</option>
              <option value="Return">Return Discount</option>
            </select>
          </div>
          <div class="input-group">
            <label>Period *</label>
            <select v-model="editingItem.period">
              <option value="" disabled selected>Select period</option>
              <option :value="3">03 Days</option>
              <option :value="7">07 Days</option>
              <option :value="60">60 Days</option>
            </select>
          </div>
          <div class="input-group">
            <label>Group Description</label>
            <div class="rich-text-editor">
              <div class="editor-toolbar">
                <v-icon size="16">mdi-undo</v-icon>
                <v-icon size="16">mdi-redo</v-icon>
                <span class="divider"></span>
                <v-icon size="16">mdi-format-bold</v-icon>
                <v-icon size="16">mdi-format-italic</v-icon>
                <v-icon size="16">mdi-format-underline</v-icon>
                <v-icon size="16">mdi-format-strikethrough</v-icon>
                <span class="divider"></span>
                <v-icon size="16">mdi-format-align-left</v-icon>
                <v-icon size="16">mdi-format-align-center</v-icon>
                <v-icon size="16">mdi-format-align-right</v-icon>
                <v-icon size="16">mdi-format-align-justify</v-icon>
                <span class="divider"></span>
                <v-icon size="16">mdi-format-list-bulleted</v-icon>
                <v-icon size="16">mdi-format-list-numbered</v-icon>
                <span class="divider"></span>
                <v-icon size="16">mdi-link</v-icon>
              </div>
              <textarea v-model="editingItem.description" placeholder="Type here"></textarea>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn-update" @click="saveDiscountGroup">
            {{ isEditMode ? 'UPDATE' : 'CREATE' }}
          </button>
          <button class="btn-cancel" @click="closeModal">CANCEL</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed } from 'vue';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';

const searchQuery = ref('');
const activeDropdown = ref(null);
const currentPage = ref(1);
const rowsPerPage = ref(10);
const showModal = ref(false);
const isEditMode = ref(false);
const editingItem = ref({});

const filters = reactive({
  category: '',
  groupName: ''
});

const notification = reactive({
  show: false,
  type: 'success',
  title: '',
  message: '',
  icon: 'mdi-check-circle'
});

const discountGroups = ref([
  { id: 1, groupName: 'Group -001', discount: 10, period: 3, category: 'Cash', description: 'No' },
  { id: 2, groupName: 'Group -002', discount: 20, period: 3, category: 'Cash', description: 'No' },
  { id: 3, groupName: 'Group -003', discount: 25, period: 60, category: 'Credit', description: 'No' },
  { id: 4, groupName: 'Group -004', discount: 5, period: 7, category: 'Return', description: 'No' },
  { id: 5, groupName: 'Group -005', discount: 15, period: 60, category: 'Credit', description: 'No' }
]);

const uniqueGroupNames = computed(() => [...new Set(discountGroups.value.map(i => i.groupName))]);

const showToast = (title, message, type = 'success') => {
  notification.title = title;
  notification.message = message;
  notification.type = type;
  notification.icon = type === 'success' ? 'mdi-check-circle' : 'mdi-alert-circle';
  notification.show = true;
  setTimeout(() => { notification.show = false; }, 3000);
};

const filteredData = computed(() => {
  return discountGroups.value.filter(item => {
    const matchesSearch = item.groupName.toLowerCase().includes(searchQuery.value.toLowerCase()) || 
                          item.description.toLowerCase().includes(searchQuery.value.toLowerCase());
    const matchesCategory = filters.category === '' || item.category === filters.category;
    const matchesGroup = filters.groupName === '' || item.groupName === filters.groupName;
    return matchesSearch && matchesCategory && matchesGroup;
  });
});

const totalPages = computed(() => Math.ceil(filteredData.value.length / rowsPerPage.value) || 1);
const paginatedData = computed(() => {
  const start = (currentPage.value - 1) * rowsPerPage.value;
  return filteredData.value.slice(start, start + rowsPerPage.value);
});

const paginationRange = computed(() => {
  const start = (currentPage.value - 1) * rowsPerPage.value + 1;
  const end = Math.min(currentPage.value * rowsPerPage.value, filteredData.value.length);
  return `${start}-${String(end).padStart(2, '0')}`;
});

const toggleDropdown = (index) => {
  activeDropdown.value = activeDropdown.value === index ? null : index;
};

const goBack = () => window.history.back();

const openCreateModal = () => {
  isEditMode.value = false;
  editingItem.value = { id: Date.now(), groupName: '', discount: '', period: '', category: '', description: '' };
  showModal.value = true;
};

const editItem = (item) => {
  isEditMode.value = true;
  activeDropdown.value = null;
  editingItem.value = { ...item };
  showModal.value = true;
};

const saveDiscountGroup = () => {
  if (isEditMode.value) {
    const index = discountGroups.value.findIndex(d => d.id === editingItem.value.id);
    if (index !== -1) {
      discountGroups.value[index] = { ...editingItem.value };
      showToast('Success', 'Discount group updated successfully');
    }
  } else {
    discountGroups.value.unshift({ ...editingItem.value });
    showToast('Success', 'Discount group created successfully');
  }
  showModal.value = false;
};

const closeModal = () => {
  showModal.value = false;
};

const deleteItem = (item) => {
  discountGroups.value = discountGroups.value.filter(d => d.id !== item.id);
  activeDropdown.value = null;
  showToast('Deleted', 'Discount group removed.', 'error');
};

const exportToPDF = () => {
  const doc = new jsPDF();
  doc.text("Discount Groups List", 14, 15);
  doc.autoTable({
    startY: 20,
    head: [['Group Name', 'Discount %', 'Period', 'Category', 'Description']],
    body: filteredData.value.map(i => [i.groupName, `${i.discount}%`, `${i.period} Days`, i.category, i.description]),
  });
  doc.save('Discount_Groups.pdf');
  showToast('Exported', 'PDF report downloaded.');
};

const exportToExcel = () => {
  const ws = XLSX.utils.json_to_sheet(filteredData.value);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Discounts");
  XLSX.writeFile(wb, "Discount_Groups.xlsx");
  showToast('Exported', 'Excel file downloaded.');
};
</script>

<style scoped>
.discount-management-container { padding: 25px; background-color: #fdfdfe; min-height: 100vh; font-family: 'Inter', sans-serif; }
.header-section { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 25px; }
.title-area h2 { font-size: 1.3rem; font-weight: 700; color: #404a5f; margin: 0; }
.title-area p { font-size: 0.85rem; color: #949eb0; margin-top: 4px; }
.btn-back { background: none; border: none; font-weight: 800; color: #404a5f; cursor: pointer; display: flex; align-items: center; gap: 5px; font-size: 0.9rem; }

.main-card { background: white; border: 1px solid #f0f2f5; border-radius: 12px; padding: 25px; box-shadow: 0 4px 6px rgba(0,0,0,0.01); }
.card-header-row { display: flex; justify-content: space-between; align-items: center; margin-bottom: 30px; }
.action-header-btns { display: flex; gap: 12px; }

.btn-create-outline { border: 1px solid #e2e8f0; background: white; border-radius: 8px; padding: 10px 18px; font-size: 0.75rem; font-weight: 700; color: #4b5563; cursor: pointer; }
.export-btn { border-radius: 6px; border: 1px solid; padding: 8px 16px; font-size: 0.8rem; font-weight: 600; cursor: pointer; display: flex; align-items: center; }
.export-btn.pdf { border-color: #3b82f6; background-color: #eff6ff; color: #1e40af; }
.export-btn.excel { border-color: #a855f7; background-color: #f5f3ff; color: #6b21a8; }

.filters-row { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 20px; margin-bottom: 25px; }
.filter-item { border: 1px solid #cbd5e1; border-radius: 8px; padding: 0 15px 10px; position: relative; }
.filter-item label { position: absolute; top: -10px; left: 15px; background: white; padding: 0 5px; font-size: 0.75rem; font-weight: 600; color: #64748b; }
.filter-item select, .filter-item input { width: 100%; border: none; outline: none; margin-top: 10px; font-size: 0.9rem; color: #1e293b; background: transparent; }

.discount-table { width: 100%; border-collapse: collapse; }
.discount-table th { text-align: left; padding: 16px; font-size: 0.75rem; color: #475569; border-bottom: 1px solid #f1f3f7; font-weight: 700; }
.discount-table td { padding: 16px; font-size: 0.85rem; color: #334155; border-bottom: 1px solid #f8fafc; }

.actions-trigger { background-color: #f3e8ff; color: #9333ea; border: none; padding: 8px 18px; border-radius: 8px; font-weight: 700; font-size: 0.75rem; cursor: pointer; display: inline-flex; align-items: center; gap: 8px; }
.dropdown-container { position: relative; }
.actions-menu { position: absolute; right: 0; top: 110%; background: white; border: 1px solid #f0f2f5; border-radius: 8px; box-shadow: 0 8px 16px rgba(0,0,0,0.08); z-index: 50; min-width: 130px; padding: 5px 0; }
.menu-opt { padding: 10px 15px; font-size: 0.85rem; color: #334155; cursor: pointer; text-align: left; }
.menu-opt:hover { background: #f8fafc; }
.menu-opt.delete { color: #ef4444; }

.pagination-bar { display: flex; justify-content: space-between; align-items: center; padding-top: 25px; margin-top: 15px; border-top: 1px solid #f1f3f7; }
.page-range { font-size: 0.85rem; font-weight: 600; color: #64748b; }
.pagination-right { display: flex; align-items: center; gap: 20px; }
.rows-select { border: none; font-weight: 700; color: #1e293b; cursor: pointer; }
.nav-arrows { display: flex; align-items: center; border: 1px solid #e2e8f0; border-radius: 6px; padding: 3px 10px; gap: 12px; }
.arrow-btn { background: none; border: none; cursor: pointer; color: #94a3b8; display: flex; }
.current-total { font-size: 0.8rem; font-weight: 700; color: #1e293b; }

.modal-overlay { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.2); display: flex; align-items: center; justify-content: center; z-index: 1000; }
.modal-content { background: white; border-radius: 12px; width: 500px; max-width: 90%; overflow: hidden; box-shadow: 0 10px 25px rgba(0,0,0,0.1); }
.modal-header { display: flex; justify-content: space-between; align-items: center; padding: 15px 20px; background: #f1f3f7; border-bottom: 1px solid #e2e8f0; }
.modal-header h3 { font-size: 0.9rem; font-weight: 700; color: #404a5f; margin: 0; }
.close-modal { background: none; border: none; font-size: 1.5rem; cursor: pointer; color: #94a3b8; }
.modal-body { padding: 20px; display: flex; flex-direction: column; gap: 15px; }
.input-group { display: flex; flex-direction: column; border: 1px solid #cbd5e1; border-radius: 8px; padding: 0 12px 8px; position: relative; }
.input-group label { position: absolute; top: -10px; left: 10px; background: white; padding: 0 5px; font-size: 0.75rem; font-weight: 600; color: #64748b; }
.input-group input, .input-group select { border: none; outline: none; margin-top: 10px; font-size: 0.9rem; width: 100%; }
.rich-text-editor { margin-top: 10px; border: 1px solid #e2e8f0; border-radius: 4px; }
.editor-toolbar { display: flex; gap: 8px; padding: 8px; background: #fafafa; border-bottom: 1px solid #e2e8f0; align-items: center; flex-wrap: wrap; }
.editor-toolbar .v-icon { color: #94a3b8; cursor: pointer; }
.divider { width: 1px; height: 15px; background: #e2e8f0; margin: 0 4px; }
.rich-text-editor textarea { width: 100%; border: none; min-height: 80px; padding: 10px; outline: none; resize: none; font-family: inherit; }
.modal-footer { padding: 15px 20px; display: flex; gap: 10px; justify-content: center; }
.btn-update { background: #8E44AD; color: #ffffff; border: none; padding: 10px 30px; border-radius: 6px; font-weight: 700; cursor: pointer; }
.btn-cancel { border: 1px solid #e2e8f0; background: white; padding: 10px 30px; border-radius: 6px; font-weight: 700; cursor: pointer; color: #64748b; }

.toast-notification { position: fixed; top: 25px; right: 25px; min-width: 320px; padding: 16px; border-radius: 10px; display: flex; align-items: center; gap: 15px; z-index: 2000; box-shadow: 0 12px 24px rgba(0,0,0,0.12); }
.toast-notification.success { background: #10b981; color: white; }
.toast-notification.error { background: #ef4444; color: white; }
.toast-content { display: flex; flex-direction: column; }
.toast-title { font-weight: 800; font-size: 0.9rem; }
.toast-msg { font-size: 0.8rem; opacity: 0.9; }

.toast-enter-active, .toast-leave-active { transition: all 0.4s ease; }
.toast-enter-from, .toast-leave-to { transform: translateX(50px); opacity: 0; }
.text-right { text-align: right; }
</style> -->






<template>
  <div class="discount-management-container">
    <transition name="toast">
      <div v-if="notification.show" class="toast-notification" :class="notification.type">
        <v-icon size="20" color="white">{{ notification.icon }}</v-icon>
        <div class="toast-content">
          <span class="toast-title">{{ notification.title }}</span>
          <span class="toast-msg">{{ notification.message }}</span>
        </div>
      </div>
    </transition>

    <div class="header-section">
      <div class="title-area">
        <h2>DISCOUNT GROUPS</h2>
        <p>Analyse the created discount group list using a variety of parameters.</p>
      </div>
      <!-- <button class="btn-back" @click="goBack">
        <v-icon size="18" color="#404a5f">mdi-menu-left</v-icon> BACK
      </button> -->
      <button class="btn-back" @click="goBack">
        <span class="back-arrow">◀</span> BACK
      </button>
    </div>

    <div class="main-card">
      <div class="card-header-row">
        <div class="search-wrapper">
          <v-icon class="search-icon" size="20">mdi-magnify</v-icon>
          <input type="text" v-model="searchQuery" placeholder="Search groups..." class="top-search-input" />
        </div>
        <div class="action-header-btns">
          <button class="btn-create-outline" @click="openCreateModal">CREATE DISCOUNT GROUP</button>
          <button class="export-btn pdf" @click="exportToPDF">
            <v-icon size="18" class="mr-1">mdi-file-pdf-box</v-icon> PDF
          </button>
          <button class="export-btn excel" @click="exportToExcel">
            <v-icon size="18" class="mr-1">mdi-microsoft-excel</v-icon> EXCEL
          </button>
        </div>
      </div>

      <div class="filters-container">
        <div class="filters-header" @click="isFilterVisible = !isFilterVisible">
          <div class="filter-title">
            <v-icon size="20" class="mr-2">mdi-filter-variant</v-icon>
            <span>FILTERS</span>
          </div>
          <v-icon>{{ isFilterVisible ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
        </div>
        
        <transition name="fade">
          <div v-if="isFilterVisible" class="filters-grid">
            <div class="filter-item">
              <label>Category</label>
              <select v-model="filters.category">
                <option value="">Select discount category</option>
                <option value="Cash">Cash</option>
                <option value="Credit">Credit</option>
                <option value="Return">Return</option>
              </select>
            </div>
            <div class="filter-item">
              <label>Group Name</label>
              <select v-model="filters.groupName">
                <option value="">Select group name</option>
                <option v-for="name in uniqueGroupNames" :key="name" :value="name">{{ name }}</option>
              </select>
            </div>
          </div>
        </transition>
      </div>

      <div class="table-container">
        <table class="discount-table">
          <thead>
            <tr>
              <th>GROUP NAME</th>
              <th>DISCOUNT %</th>
              <th>PERIOD</th>
              <th>CATEGORY</th>
              <th>DESCRIPTION</th>
              <th class="text-right">ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in paginatedData" :key="index">
              <td class="font-bold">{{ item.groupName }}</td>
              <td class="discount-text">{{ item.discount }}%</td>
              <td>{{ item.period }} Days</td>
              <td>
                <div class="status-pill-blue">
                  {{ item.category }} <v-icon size="14">mdi-check</v-icon>
                </div>
              </td>
              <td class="description-cell">{{ item.description }}</td>
              <td class="text-right">
                <div class="dropdown-container">
                  <button @click="toggleDropdown(index)" class="actions-purple-btn">
                    ACTIONS <v-icon size="18">mdi-chevron-down</v-icon>
                  </button>
                  <div v-if="activeDropdown === index" class="actions-menu">
                    <div class="menu-opt edit" @click="editItem(item)">EDIT</div>
                    <div class="menu-opt delete" @click="deleteItem(item)">DELETE</div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="pagination-bar">
        <div class="page-range">
          {{ paginationRange }} of {{ filteredData.length }}
        </div>
        <div class="pagination-right">
          <span class="rows-label">Rows per page:</span>
          <select v-model="rowsPerPage" class="rows-select">
            <option :value="5">05</option>
            <option :value="10">10</option>
          </select>
          <div class="nav-arrows">
            <button :disabled="currentPage === 1" @click="currentPage--" class="arrow-btn">
              <v-icon size="18">mdi-chevron-left</v-icon>
            </button>
            <span class="current-total">{{ currentPage }}/{{ totalPages }}</span>
            <button :disabled="currentPage === totalPages" @click="currentPage++" class="arrow-btn">
              <v-icon size="18">mdi-chevron-right</v-icon>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showModal" class="modal-overlay">
      <div class="modal-content">
        <div class="modal-header">
          <h3>{{ isEditMode ? 'UPDATE DISCOUNT GROUP' : 'CREATE DISCOUNT GROUP' }}</h3>
          <button class="close-modal" @click="closeModal">×</button>
        </div>
        <div class="modal-body">
          <div class="input-group">
            <label>Group Name *</label>
            <input type="text" v-model="editingItem.groupName" />
          </div>
          <div class="input-group">
            <label>Discount *</label>
            <input type="text" v-model="editingItem.discount" />
          </div>
          <div class="input-group">
            <label>Group Category *</label>
            <select v-model="editingItem.category">
              <option value="Cash">Cash</option>
              <option value="Credit">Credit</option>
              <option value="Return">Return</option>
            </select>
          </div>
          <div class="input-group">
            <label>Period *</label>
            <select v-model="editingItem.period">
              <option :value="3">3 Days</option>
              <option :value="7">7 Days</option>
              <option :value="60">60 Days</option>
            </select>
          </div>
          <div class="input-group">
            <label>Description</label>
            <textarea v-model="editingItem.description" class="simple-textarea"></textarea>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn-update" @click="saveDiscountGroup">
            {{ isEditMode ? 'UPDATE' : 'CREATE' }}
          </button>
          <button class="btn-cancel" @click="closeModal">CANCEL</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed } from 'vue';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';

const searchQuery = ref('');
const activeDropdown = ref(null);
const currentPage = ref(1);
const rowsPerPage = ref(10);
const showModal = ref(false);
const isEditMode = ref(false);
const editingItem = ref({});
const isFilterVisible = ref(true);

const filters = reactive({
  category: '',
  groupName: ''
});

const notification = reactive({
  show: false,
  type: 'success',
  title: '',
  message: '',
  icon: 'mdi-check-circle'
});

const discountGroups = ref([
  { id: 1, groupName: 'Group -001', discount: 10, period: 3, category: 'Cash', description: 'Standard cash discount' },
  { id: 2, groupName: 'Group -002', discount: 20, period: 3, category: 'Cash', description: 'Promotional discount' },
  { id: 3, groupName: 'Group -003', discount: 25, period: 60, category: 'Credit', description: 'Long term credit group' },
  { id: 4, groupName: 'Group -004', discount: 5, period: 7, category: 'Return', description: 'Return adjustment group' }
]);

const uniqueGroupNames = computed(() => [...new Set(discountGroups.value.map(i => i.groupName))]);

const showToast = (title, message, type = 'success') => {
  notification.title = title;
  notification.message = message;
  notification.type = type;
  notification.icon = type === 'success' ? 'mdi-check-circle' : 'mdi-alert-circle';
  notification.show = true;
  setTimeout(() => { notification.show = false; }, 3000);
};

const filteredData = computed(() => {
  return discountGroups.value.filter(item => {
    const searchLower = searchQuery.value.toLowerCase();
    const matchesSearch = item.groupName.toLowerCase().includes(searchLower) || 
                          item.description.toLowerCase().includes(searchLower);
    const matchesCategory = filters.category === '' || item.category === filters.category;
    const matchesGroup = filters.groupName === '' || item.groupName === filters.groupName;
    return matchesSearch && matchesCategory && matchesGroup;
  });
});

const totalPages = computed(() => Math.ceil(filteredData.value.length / rowsPerPage.value) || 1);
const paginatedData = computed(() => {
  const start = (currentPage.value - 1) * rowsPerPage.value;
  return filteredData.value.slice(start, start + rowsPerPage.value);
});

const paginationRange = computed(() => {
  const start = (currentPage.value - 1) * rowsPerPage.value + 1;
  const end = Math.min(currentPage.value * rowsPerPage.value, filteredData.value.length);
  return `${start}-${String(end).padStart(2, '0')}`;
});

const toggleDropdown = (index) => {
  activeDropdown.value = activeDropdown.value === index ? null : index;
};

const goBack = () => window.history.back();

const openCreateModal = () => {
  isEditMode.value = false;
  editingItem.value = { id: Date.now(), groupName: '', discount: '', period: '', category: '', description: '' };
  showModal.value = true;
};

const editItem = (item) => {
  isEditMode.value = true;
  activeDropdown.value = null;
  editingItem.value = { ...item };
  showModal.value = true;
};

const saveDiscountGroup = () => {
  if (isEditMode.value) {
    const index = discountGroups.value.findIndex(d => d.id === editingItem.value.id);
    if (index !== -1) {
      discountGroups.value[index] = { ...editingItem.value };
      showToast('Success', 'Discount group updated successfully');
    }
  } else {
    discountGroups.value.unshift({ ...editingItem.value });
    showToast('Success', 'Discount group created successfully');
  }
  showModal.value = false;
};

const closeModal = () => {
  showModal.value = false;
};

const deleteItem = (item) => {
  discountGroups.value = discountGroups.value.filter(d => d.id !== item.id);
  activeDropdown.value = null;
  showToast('Deleted', 'Discount group removed.', 'error');
};

const exportToPDF = () => {
  const doc = new jsPDF();
  doc.text("Discount Groups List", 14, 15);
  doc.autoTable({
    startY: 20,
    head: [['Group Name', 'Discount %', 'Period', 'Category', 'Description']],
    body: filteredData.value.map(i => [i.groupName, `${i.discount}%`, `${i.period} Days`, i.category, i.description]),
  });
  doc.save('Discount_Groups.pdf');
  showToast('Exported', 'PDF report downloaded.');
};

const exportToExcel = () => {
  const ws = XLSX.utils.json_to_sheet(filteredData.value);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Discounts");
  XLSX.writeFile(wb, "Discount_Groups.xlsx");
  showToast('Exported', 'Excel file downloaded.');
};
</script>

<style scoped>
.discount-management-container { padding: 25px; background-color: #fdfdfe; min-height: 100vh; font-family: 'Inter', sans-serif; }
.header-section { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 25px; }
.title-area h2 { font-size: 1.5rem; font-weight: 700; color: #404a5f; margin: 0; }
.title-area p { font-size: 0.9rem; color: #949eb0; margin-top: 4px; }
/* .btn-back { background: white; border: 1px solid #e2e8f0; border-radius: 4px; padding: 6px 12px; font-weight: 700; color: #404a5f; cursor: pointer; display: flex; align-items: center; gap: 5px; } */
.btn-back {
  background: rgba(255, 255, 255, 0);
  /* border: 1px solid #e2e8f0;
  border-radius: 6px; */
  font-weight: 700;
  color: #2d3748;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.2rem;
  padding: 8px 16px;
}



.main-card { background: white; padding: 20px; border-radius: 4px; border: 1px solid #f0f2f5; }
.card-header-row { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; }
.search-wrapper { position: relative; width: 300px; }
.search-icon { position: absolute; left: 10px; top: 50%; transform: translateY(-50%); color: #94a3b8; }
.top-search-input { width: 100%; padding: 8px 10px 8px 35px; border: 1px solid #e2e8f0; border-radius: 6px; outline: none; font-size: 0.9rem; }

.action-header-btns { display: flex; gap: 10px; }
.btn-create-outline { border: 1px solid #e2e8f000; background: rgba(255, 255, 255, 0); border-radius: 4px; padding: 8px 16px; font-size: 1.0rem; font-weight: 700; color: #4b5563; cursor: pointer; }
.export-btn { border: none; border-radius: 4px; padding: 8px 22px; color: white; font-weight: bold; font-size: 0.8rem; display: flex; align-items: center; cursor: pointer; }
.export-btn.pdf { background-color: #0b4a99; }
.export-btn.excel { background-color: #004d3d; }

.filters-container { border: 1px solid #e2e8f0; border-radius: 4px; margin-bottom: 25px; }
.filters-header { padding: 12px 15px; display: flex; justify-content: space-between; cursor: pointer; background: #fff; }
.filter-title { display: flex; align-items: center; font-weight: 700; color: #404a5f; font-size: 0.85rem; letter-spacing: 0.5px; }
.filters-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 20px; padding: 30px 20px; border-top: 1px solid #e2e8f0; }

.filter-item { border: 1px solid #cbd5e1; border-radius: 6px; padding: 8px 12px; position: relative; }
.filter-item label { position: absolute; top: -10px; left: 10px; background: white; padding: 0 5px; font-size: 0.75rem; font-weight: 600; color: #64748b; }
.filter-item select { width: 100%; border: none; outline: none; margin-top: 5px; font-size: 0.9rem; color: #94a3b8; background: transparent; }

.discount-table { width: 100%; border-collapse: collapse; }
.discount-table th { text-align: left; padding: 12px 15px; font-size: 0.75rem; color: #404a5f; border-bottom: 1px solid #e2e8f0; font-weight: 700; text-transform: uppercase; }
.discount-table td { padding: 20px 15px; border-bottom: 1px solid #f1f3f7; vertical-align: middle; font-size: 0.85rem; }

.status-pill-blue { border: 1px solid #0b4a99; color: #0b4a99; padding: 4px 10px; border-radius: 4px; font-weight: 800; font-size: 0.7rem; display: flex; align-items: center; justify-content: space-between; background: #f0f7ff; width: 100px; }
.discount-text { color: #0b4a99; font-weight: 700; }
.font-bold { font-weight: 700; color: #404a5f; }
.description-cell { color: #64748b; max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

.actions-purple-btn { background-color: #8e44ad; color: white; border: none; padding: 8px 16px; border-radius: 4px; font-weight: 700; font-size: 0.8rem; display: flex; align-items: center; gap: 8px; cursor: pointer; }
.dropdown-container { position: relative; display: inline-block; }
.actions-menu { position: absolute; right: 0; top: 110%; background: white; border: 1px solid #e2e8f0; border-radius: 4px; box-shadow: 0 4px 12px rgba(0,0,0,0.1); z-index: 50; min-width: 120px; }
.menu-opt { padding: 10px 15px; font-size: 0.85rem; cursor: pointer; text-align: left; color: #404a5f; }
.menu-opt:hover { background: #f8fafc; }
.menu-opt.delete { color: #ef4444; font-weight: 500; }
.menu-opt.edit { color: #388a11; font-weight: 500; }

.pagination-bar { display: flex; justify-content: space-between; align-items: center; padding-top: 25px; margin-top: 15px; }
.page-range { font-size: 0.85rem; font-weight: 600; color: #64748b; }
.pagination-right { display: flex; align-items: center; gap: 20px; }
.rows-select { border: none; font-weight: 700; color: #1e293b; outline: none; cursor: pointer; }
.nav-arrows { display: flex; align-items: center; border: 1px solid #e2e8f0; border-radius: 4px; padding: 4px 10px; gap: 12px; }
.arrow-btn { background: none; border: none; cursor: pointer; color: #94a3b8; display: flex; }

.modal-overlay { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.3); display: flex; align-items: center; justify-content: center; z-index: 1000; }
.modal-content { background: white; border-radius: 8px; width: 450px; }
.modal-header { padding: 15px 20px; background: #f8fafc; border-bottom: 1px solid #e2e8f0; display: flex; justify-content: space-between; align-items: center; border-radius: 8px 8px 0 0; }
.modal-body { padding: 20px; display: flex; flex-direction: column; gap: 20px; }
.input-group { border: 1px solid #cbd5e1; border-radius: 6px; padding: 8px 12px; position: relative; }
.input-group label { position: absolute; top: -10px; left: 10px; background: white; padding: 0 5px; font-size: 0.75rem; font-weight: 600; color: #64748b; }
.input-group input, .input-group select, .input-group textarea { width: 100%; border: none; outline: none; margin-top: 5px; font-size: 0.9rem; background: transparent; }
.simple-textarea { min-height: 60px; resize: none; }
.modal-footer { padding: 15px 20px; display: flex; gap: 10px; justify-content: center; }
.btn-update { background: #8e44ad; color: white; border: none; padding: 10px 30px; border-radius: 4px; font-weight: 700; cursor: pointer; }
.btn-cancel { border: 1px solid #e2e8f0; background: white; padding: 10px 30px; border-radius: 4px; font-weight: 700; color: #64748b; cursor: pointer; }

.toast-notification { position: fixed; top: 20px; right: 20px; min-width: 300px; padding: 15px; border-radius: 8px; display: flex; align-items: center; gap: 12px; z-index: 2000; }
.toast-notification.success { background: #10b981; color: white; }
.toast-notification.error { background: #ef4444; color: white; }
</style>